import Vue from 'vue';
import vueKanban from 'vue-kanban-atlas';
Vue.use(vueKanban);
